import {gsap} from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger)

import { enlargeThumb, closeThumbOverlay } from './thumbAnimation';



// ******************
// Selectors
// ******************
const crosses = document.querySelectorAll('.pacs--featCol__cross')
const pageTitle = document.querySelector('.pacs--mainCol__title')
const mainDescription = document.querySelector('.pacs--mainCol__description')
const heroImg = document.getElementById('heroImg')
const ctaButton = document.querySelector('.ctaButton')
const features = document.querySelectorAll('.pacs--featCol__item')
const functionBar = document.querySelector('.pacs--featCol__bar')
const functionTitle = document.querySelector('.pacs--featCol__title')
// Functions
const thumbs = document.querySelectorAll('.pacs--featCol__item-photo img')
// Benefits
const benefitsSection = document.querySelector('.pacsBenefits')
const benefitsTitle = document.querySelector('.pacsBenefits--title')
const benefitsBar = document.querySelector('.pacsBenefits--bar')
const benefitsItems = document.querySelectorAll('.pacsBenefits--item')

// Title animation
window.addEventListener('load', () => {
  if(window.innerWidth <= 768) {
    const titleAnimation = gsap.timeline()
    .from({}, {duration: 1})
    .from(pageTitle, {y: '50%', opacity: 0})
    .from(mainDescription, {y: 30, opacity: 0}, '-=.4')
    .from(ctaButton, {x: -50, opacity: 0, ease: 'back'}, '-=.3')
    .from(heroImg, {y: 50, opacity: 0}, '<')
  } else {
    // console.log('big')
    const titleAnimation = gsap.timeline()
    .from({}, {duration: 1})
    .from(pageTitle, {y: '50%', opacity: 0})
    .from(mainDescription, {y: 30, opacity: 0}, '-=.4')
    .from(ctaButton, {x: -50, opacity: 0, ease: 'back'}, '-=.3')
    .from(heroImg, {y: 50, opacity: 0}, '<')
    .from(functionTitle, {y: 30, opacity: 0}, '<')
    .from(functionBar, {scaleX: 0}, '-=.3')
    .from([features], {x: 100, opacity: 0, stagger: 0.2}, '<')
  }
})





// ******************
// Unfold animation
// ******************
crosses.forEach((cross) => {
  cross.addEventListener('click', () => {
    // Selectors
    const viewportWidth = window.innerWidth
    const line1 = cross.querySelector('.pacs--featCol__cross-line_1')
    const content = cross.parentElement.parentElement.querySelector('.pacs--featCol__item-content')
    const header = cross.parentElement.parentElement.querySelector('.pacs--featCol__item-header')

    // Less than tablet
    if(viewportWidth <= 768) {
      // console.log('phone size')
      cross.classList.toggle('active')
      
      if(cross.classList.contains('active')) {
        const openAnim = gsap.timeline()
        .to(line1, {rotate: '0deg'})
        .to(content, {height: 'auto', padding: '1em'}, '<')
      } else {
        const closeAnim = gsap.timeline()
        .to(line1, {rotate: '-90deg'})
        .to(content, {height: 0, padding: 0}, '<')
      }
    }

    // Tablet
    if (viewportWidth > 768) {
      // console.log('tablet size')
      // Selectors
      const items = document.querySelectorAll('.pacs--featCol__item')
      const previousActiveCross = document.querySelector('.pacs--featCol__cross.active')

      // Current item index
      const currentItem = cross.parentElement.parentElement
      const currentIndex = Array.prototype.indexOf.call(items, currentItem)

      // If active cross find parent item index
      let previousIndex = null
      let previousActiveItem = null
      if(previousActiveCross) {
        previousActiveItem = previousActiveCross.parentElement.parentElement
        previousIndex = Array.prototype.indexOf.call(items, previousActiveItem)
      }

      cross.classList.toggle('active')

      // First choice
      if(previousIndex == null) {
        // console.log('first choice')
        if(cross.classList.contains('active')) {
          const openAnim = gsap.timeline()
          .to(line1, {rotate: '0deg'})
          .to(content, {height: 'auto', padding: '1em'}, '<')
          .to(header, {backgroundColor: '#edf8fd'}, '<')
        } else {
          const closeAnim = gsap.timeline()
          .to(line1, {rotate: '-90deg'})
          .to(content, {height: 0, padding: 0}, '<')
          .to(header, {backgroundColor: 'white'}, '<')
        }
      }

      // Not same item choice
      if( previousIndex != null && previousIndex != currentIndex) {
        // console.log('not same index')
        const previousLine1 = previousActiveCross.querySelector('.pacs--featCol__cross-line_1')
        const previousContent = previousActiveItem.querySelector('.pacs--featCol__item-content')
        const previousHeader = previousActiveItem.querySelector('.pacs--featCol__item-header')
        previousActiveCross.classList.remove('active')

        if(cross.classList.contains('active')) {
          const openAnim = gsap.timeline()
          .to(previousLine1, {rotate: '-90deg'})
          .to(previousContent, {height: 0, padding: 0}, '<')
          .to(previousHeader, {backgroundColor: 'white'}, '<')
          .to(line1, {rotate: '0deg'}, '<')
          .to(content, {height: 'auto', padding: '1em'}, '<')
          .to(header, {backgroundColor: '#edf8fd'}, '<')

        } 
      }
      
      // Same item choice
      if (previousIndex == currentIndex) {
        // console.log('same index')
        if(cross.classList.contains('active')) {
          const openAnim = gsap.timeline()
          .to(line1, {rotate: '0deg'})
          .to(content, {height: 'auto', padding: '1em'}, '<')
          .to(header, {backgroundColor: '#edf8fd'}, '<')

        } else {
          const closeAnim = gsap.timeline()
          .to(line1, {rotate: '-90deg'})
          .to(content, {height: 0, padding: 0}, '<')
          .to(header, {backgroundColor: 'white'}, '<')
        }
      }
    }

  })
})



// ******************
// Enlarge thumbnails
// ******************
thumbs.forEach((thumb) => {
  if(window.innerWidth >= 768) {
    thumb.addEventListener('click', () => {
      const imgSrc = thumb.src
      enlargeThumb(imgSrc)
    })
  } else return
})

// ******************
// Benefits Animation
// ******************
const benefitAnimation = gsap.timeline({
  scrollTrigger: {
    trigger: benefitsSection,
    start: 'top 70%'
  }
})
.from(benefitsTitle, {y: 30, opacity: 0})
.from(benefitsBar, {scaleX: 0, duration: 1}, '<')
.from([benefitsItems], {y: 30, opacity: 0, stagger: 0.2}, '<')


